import { createContext } from 'react';

const ControlBarContext = createContext();
const PuzzleContext = createContext();

export { ControlBarContext, PuzzleContext };
